"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CountdownTimer = require("./styles/CountdownTimer");
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CountdownTimer = ({
  targetDate,
  onComplete,
  completedMessage
}) => {
  const [timeLeft, setTimeLeft] = (0, _react.useState)({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    isCompleted: false
  });
  (0, _react.useEffect)(() => {
    const calculateTimeLeft = () => {
      const endTime = new Date(targetDate).getTime();
      const now = new Date().getTime();
      const difference = endTime - now;
      if (difference <= 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0,
          isCompleted: true
        });
        onComplete?.();
        return;
      }
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor(difference % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      const minutes = Math.floor(difference % (1000 * 60 * 60) / (1000 * 60));
      const seconds = Math.floor(difference % (1000 * 60) / 1000);
      setTimeLeft({
        days,
        hours,
        minutes,
        seconds,
        isCompleted: false
      });
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, [targetDate, onComplete]);
  if (timeLeft.isCompleted) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "countdown-completed"
    }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
      id: completedMessage || 'countdownTimer.completedMessage'
    }));
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "countdown-timer-container",
    "data-cy": "countdown-timer-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex"
  }, timeLeft.days > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.days), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.days"
  }))), timeLeft.hours > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.hours), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.hours"
  }))), timeLeft.minutes > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.minutes), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.minutes"
  }))), timeLeft.seconds > 0 && /*#__PURE__*/_react.default.createElement(_CountdownTimer.CountdownUnit, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-value"
  }, timeLeft.seconds), /*#__PURE__*/_react.default.createElement("span", {
    className: "countdown-label"
  }, ' ', /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: "countdownTimer.seconds"
  })))));
};
CountdownTimer.propTypes = {
  targetDate: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]).isRequired,
  onComplete: _propTypes.default.func,
  completedMessage: _propTypes.default.string
};
var _default = exports.default = CountdownTimer;